__turbopack_context__.v({
  "dialog": "dialog-module-scss-module__Hb8cKW__dialog",
  "dialog__content": "dialog-module-scss-module__Hb8cKW__dialog__content",
  "dialog__footer": "dialog-module-scss-module__Hb8cKW__dialog__footer",
  "dialog__header": "dialog-module-scss-module__Hb8cKW__dialog__header",
  "dialog__loading-area": "dialog-module-scss-module__Hb8cKW__dialog__loading-area",
  "dialog__title": "dialog-module-scss-module__Hb8cKW__dialog__title",
});
